<template>
	<div class="footer">
		<router-link to="/home" tag="div" class="footer-item">
        <i class="iconfont icon-home"></i>
		<div class="nav-text">首页</div></router-link>
		<router-link to="/plan" tag="div" class="footer-item">
        <i class="iconfont icon-barchart"></i>
		<div class="nav-text">计划</div></router-link>
		<router-link to="/record" tag="div" class="footer-item">
        <i class="iconfont icon-piechart"></i>
		<div class="nav-text">数据</div></router-link>
	</div>
</template>

<script>
	export default {
		name: 'VFooter'
	}
</script>


<style lang="stylus">
	.footer
		position: fixed;
		left: 0
		right: 0
		bottom: 0
		z-index: 1
		display: flex
		width: 100%
		background-color: #ffffff
		.footer-item
			flex: 1
			height: auto
			text-align: center
			padding:5px 0
			.iconfont
				color:#333
				font-size:0.6rem
				margin-bottom:3px
		.nav-text
			font-size:10px
			margin:3px 0

		.router-link-active
			color: #09f
			.iconfont
				color: #09f
</style>



// WEBPACK FOOTER //
// src/pages/components/v-footer.vue